import { render, staticRenderFns } from "./LottieFile.vue?vue&type=template&id=64dc5148"
import script from "./LottieFile.vue?vue&type=script&lang=js"
export * from "./LottieFile.vue?vue&type=script&lang=js"
import style0 from "./LottieFile.vue?vue&type=style&index=0&id=64dc5148&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports